export default "__VITE_ASSET__Dp6qGecv__"